import Map from './map.vue';

Map.install = function(Vue) {
  Vue.component(Map.name, Map);
};

export default Map;



// WEBPACK FOOTER //
// ./src/packages/map/index.js